<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Name" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" />
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Password" v-model="data_local.password" v-validate="'required|min:8'" name="password" />
          <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">

        <div class="mt-4">
          <label class="vs-input--label">State</label>
          <v-select v-model="data_local.state" :clearable="false" @search="onSearchState" multiple :filterable="false" @input="changeCounties" :options="stateOptions" v-validate="'required'" name="county" :dir="$vs.rtl ? 'rtl' : 'ltr'"  :closeOnSelect="false">
            <template slot="no-options">
              Type to search State
            </template>
            <template slot="option" slot-scope="stateOptions">
              <div class="d-center">
                {{ stateOptions.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="stateOptions">
              <div class="selected d-center">
                {{ stateOptions.label }}
              </div>
            </template>
          </v-select>
          <span class="text-danger text-sm"  v-show="errors.has('county')">{{ errors.first('county') }}</span>
        </div>
        <div class="mt-4">
          <label class="vs-input--label">County</label>
          <v-select v-model="data_local.county" :clearable="false" @search="onSearch" multiple :filterable="false" :options="countyOptions" v-validate="'required'" name="county" :dir="$vs.rtl ? 'rtl' : 'ltr'"  :closeOnSelect="false">
            <template slot="no-options">
              Select state and type to search counties
            </template>
            <template slot="option" slot-scope="countyOptions">
              <div class="d-center">
                {{ countyOptions.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="countyOptions">
              <div class="selected d-center">
                {{ countyOptions.label }}
              </div>
            </template>
          </v-select>
          <span class="text-danger text-sm"  v-show="errors.has('county')">{{ errors.first('county') }}</span>
        </div>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import _ from 'lodash'
import axios from '@/axios.js'

export default {
  components: {
    vSelect
  },
  data () {
    return {

      data_local: {
        name: '',
        email: '',
        county: [],
        state: [],
        password: ''
      },

      stateOptions: [],
      countyOptions: []
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    changeCounties (val) {
      const stateCode = []
      val.forEach(function (item) {
        stateCode.push(item.state_code)
      })
      axios
        .post('/api/admin/get/counties',
          {
            county: '',
            stateCode
          })
        .then(res => {
          this.countyOptions = res.data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      axios
        .post('/api/admin/add/promoter', this.data_local)
        .then(res => {
          if(res.data.success) {
            this.$vs.notify({
              title: "Promoter Added",
              text: res.data.message,
              color: "success"
            })
            this.$router.push('/admin/users/promoter')
          }else{
            this.$vs.notify({
              title: "Error",
              text: res.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        })
        .catch(error => {
          if (error.response.status === 422) {
            if (typeof error.response.data.errors !== "undefined") {
              for (var key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key))
                  this.$vs.notify({
                    title: "Error",
                    text: error.response.data.errors[key][0],
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger"
                  })
              }
            }
          }
        })
      /* eslint-enable */
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    onSearch (search, loading) {
      loading(true)
      this.search(loading, search, this)
    },
    onSearchState (search, loading) {
      loading(true)
      this.searchState(loading, search, this)
    },
    searchState: _.debounce((loading, search, vm) => {
      if (escape(search) !== '') {
        axios
          .post('/api/admin/get/state',
            {
              state: escape(search)
            })
          .then(res => {
            vm.stateOptions = res.data.data
            loading(false)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        loading(false)
      }
    }, 350),
    search: _.debounce((loading, search, vm) => {
      if (vm.data_local.state.length > 0) {
        const stateCode = []
        vm.data_local.state.forEach(function (item) {
          stateCode.push(item.state_code)
        })
        if (escape(search) !== '') {
          axios
            .post('/api/admin/get/counties',
              {
                county: escape(search),
                stateCode
              })
            .then(res => {
              vm.countyOptions = res.data.data
              loading(false)
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          loading(false)
        }
      } else {
        loading(false)
        vm.$vs.notify({
          title: 'Error',
          text: 'Please select a state',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }, 350)
  }
}
</script>
